import React from 'react';
import { ROUTES } from 'App/Routes/constants';
import { RedirectCard } from 'commons/components';
import { useGetWithdrawalsPreferences } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import { PersonalDataMexico } from 'domains/Configuration/Mexico';

const ConfigurationMexico = () => {
  const { t } = useTranslationWithPrefix('configuration');

  const { isWithdrawalPreferencesEnabled } = useGetWithdrawalsPreferences();

  return (
    <>
      <PersonalDataMexico />
      <RedirectCard
        title={t('section.paymentMethods')}
        path={ROUTES.PAYMENT_METHODS}
      />
      {isWithdrawalPreferencesEnabled && (
        <RedirectCard
          title={t('section.withdrawsConfig')}
          path={ROUTES.WITHDRAWS_CONFIG}
          isNew
        />
      )}
      <RedirectCard
        title={t('section.installments')}
        path={ROUTES.INSTALLMENTS}
      />
    </>
  );
};

export default ConfigurationMexico;
